import { useEffect } from "react";
import { useAuth } from "react-oidc-context"; // Or your auth hook
import { tokenManager } from "@repo/services";

export const AuthTokenUpdater = () => {
  const { user } = useAuth();
  const accessToken = user?.access_token;

  useEffect(() => {
    tokenManager.setToken(accessToken || null);
  }, [accessToken]);

  return null;
};
